import React from "react";
import education from "../../data/education.json";

const Education = () => {
  return (
    <div className="new-tab-content-container">
      <div className="education-container">
        <h1>Education</h1>
        <div className="education-cover">
          {education.map((edu, i) => (
            <section className="education-card" key={i}>
              <p>{edu.period}</p>
              <strong>{edu.title}</strong>
              <h3>{edu.organization}</h3>
            </section>
          ))}
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Education;
